import React from "react";
import DistrictForm from "./DistrictForm";

export default function DistrictAdd() {
  return <DistrictForm mode="add" />;
}
